module.exports = __webpack_public_path__ + "static/empty_n.d7b180fa.png";